<div class="login-wrapper">
    <a da-link [routerLink]="targetLink">
        <span class="drg-icon-user"></span><span class="text" [innerHTML]="'login.headerLink' | translate"></span
    ></a>
</div>
